import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { DownloadVideo, PinUnpinVideoDecorated } from 'components/video-box';
import { ActionsContextMenuDecorated } from 'components/context-menu/actions-context-menu';
import { VideoShareDropdownDecorated } from 'components/context-menu/video-share-dropdown';

export const VideoControlsMenu = ({ video }) => (
  <Fragment>
    <DownloadVideo video={video} />
    <PinUnpinVideoDecorated video={video} />
    <VideoShareDropdownDecorated />
    <ActionsContextMenuDecorated video={video} />
  </Fragment>
);

VideoControlsMenu.propTypes = {
  video: PropTypes.object.isRequired,
};
